import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, AbstractControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MerchantProfileNameValidator, PersonValidator } from '../../validators';
import { PersonService, MerchantProfileService } from '../../services';
import { MerchantProfile } from '../../models';

@Component({
    selector: 'app-merchant-profile',
    templateUrl: './merchant-profile.component.html',
    styleUrls: ['./merchant-profile.component.css']
})
export class MerchantProfileComponent implements OnInit {

    @Input()
    merchantProfile: MerchantProfile;

    saving = false;
    showErrors = false;
    merchantProfileForm: FormGroup;
    get merchantProfileName(): AbstractControl {
        return this.merchantProfileForm.get('merchantProfileName');
    }
    get defaultContactPerson(): AbstractControl {
        return this.merchantProfileForm.get('defaultContactPerson');
    }
    get accessUsers(): FormArray {
        return this.merchantProfileForm.get('accessUsers') as FormArray;
    }

    constructor(
        private readonly fb: FormBuilder,
        public activeModal: NgbActiveModal,
        private readonly toastr: ToastrService,
        private readonly merchantProfileService: MerchantProfileService,
        private readonly personService: PersonService
    ) {
        
    }

    ngOnInit() {
        var accessUsersFormArray = this.merchantProfile.accessUsers.length > 0 ? this.merchantProfile.accessUsers.map((accessUser) => {
            return this.fb.control(accessUser, []);
        }) : [];
        this.merchantProfileForm = this.fb.group({
            merchantProfileName: [this.merchantProfile.name, [Validators.required], [MerchantProfileNameValidator.validate(this.merchantProfileService, this.merchantProfile.id)]],
            defaultContactPerson: [this.merchantProfile.defaultContact, [Validators.required], [PersonValidator.hasPersonCompletedCashHandlingTraining(this.personService)]],
            accessUsers: this.fb.array(accessUsersFormArray, PersonValidator.isUnique())
        });
        if (this.accessUsers.length === 0) {
            this.onAddAccessUser();
        }
    }

    onDeleteDefaultContactPerson() {
        this.defaultContactPerson.setValue(null);
        this.defaultContactPerson.updateValueAndValidity();
    }

    showAddAccessUser(): boolean {
        return this.accessUsers.valid &&
            this.accessUsers.value.every((accessUser) => {
                return accessUser != null;
            });
    }

    onAddAccessUser(): void {
        this.accessUsers.push(this.fb.control(null, []));
    }

    onDeleteAccessUser(index: any): void {
        if (this.accessUsers.length !== 1) {
            this.accessUsers.removeAt(index);
        } else {
            var accessUser = this.accessUsers.at(index);
            accessUser.setValue(null);
            accessUser.updateValueAndValidity();
        }
    }

    onSave() {
        console.log(this.merchantProfileForm);
        if (this.merchantProfileForm.valid) {
            this.saving = true;
            if (this.merchantProfile.id == null) {
                this.create();
            } else {
                this.update();
            }
        } else {
            this.showErrors = true;
        }
    }

    private create() {
        this.merchantProfileService.create(this.merchantProfileForm.value).subscribe(
            (id) => {
                this.merchantProfile.id = id;
                this.toastr.success("The Merchant Profile was successfully created!");
                this.saving = false;
                this.activeModal.close();
            },
            err => {
                this.saving = false;
                throw err;
            });
    }

    private update() {
        this.merchantProfileService.update(this.merchantProfileForm.value, this.merchantProfile.id).subscribe(
            () => {
                this.toastr.success("The Merchant Profile was successfully updated!");
                this.saving = false;
                var updatedMerchantProfile = {
                    id: this.merchantProfile.id,
                    name: this.merchantProfileName.value,
                    defaultContact: this.defaultContactPerson.value,
                    accessUsers: this.accessUsers.value
                } as MerchantProfile;
                this.activeModal.close(updatedMerchantProfile);
            },
            err => {
                this.saving = false;
                throw err;
            });
    }
}